export const companyInfo = {
  name: "DERBY",
  tagline: "Powering Connections with Quality",
  description: "Derby is a leading manufacturer and supplier of premium PVC insulated electrical wires, cables, and electrical accessories. With a commitment to quality and safety, we deliver reliable electrical solutions for residential, commercial, and industrial applications.",
  email: "info@derbywires.com",
  phone: "+1 (555) 123-4567",
  address: "123 Industrial Avenue, Business District, City, State 12345"
};

export const products = [
  {
    id: 1,
    name: "PVC Insulated Wires",
    category: "Wires",
    description: "High-quality PVC insulated electrical wires suitable for various voltage ratings and applications.",
    features: ["Flame retardant", "UV resistant", "Multiple gauge options", "ISI certified"]
  },
  {
    id: 2,
    name: "Power Cables",
    category: "Cables",
    description: "Durable power cables designed for heavy-duty industrial and commercial electrical installations.",
    features: ["High tensile strength", "Weather resistant", "Low voltage drop", "Long lifespan"]
  },
  {
    id: 3,
    name: "Control Cables",
    category: "Cables",
    description: "Specialized control cables for automation systems and industrial control applications.",
    features: ["Multi-core options", "Shielded variants", "Flexible design", "Signal integrity"]
  },
  {
    id: 4,
    name: "Flexible Wires",
    category: "Wires",
    description: "Highly flexible wires perfect for applications requiring frequent movement and bending.",
    features: ["Superior flexibility", "Durable construction", "Heat resistant", "Multiple colors"]
  },
  {
    id: 5,
    name: "Electrical Accessories",
    category: "Accessories",
    description: "Complete range of electrical accessories including switches, sockets, and connection fittings.",
    features: ["Premium materials", "Safety certified", "Easy installation", "Modern designs"]
  },
  {
    id: 6,
    name: "Junction Boxes",
    category: "Accessories",
    description: "Protective junction boxes for secure wire connections and electrical safety.",
    features: ["Weather proof", "Multiple sizes", "Impact resistant", "Easy access"]
  }
];

export const features = [
  {
    id: "premium-quality",
    title: "Premium Quality",
    description: "Manufactured using the finest materials and latest technology to ensure superior performance."
  },
  {
    id: "safety-certified",
    title: "Safety Certified",
    description: "All products meet international safety standards and are rigorously tested for reliability."
  },
  {
    id: "wide-range",
    title: "Wide Range",
    description: "Comprehensive product portfolio catering to diverse electrical requirements and applications."
  },
  {
    id: "expert-support",
    title: "Expert Support",
    description: "Dedicated technical team ready to assist with product selection and installation guidance."
  }
];
